module.exports = __webpack_public_path__ + "static/media/ee_ru_mob_r.053b98a5.png";